import { proxy } from 'valtio';

const loadingState = proxy<{
    page: boolean;
    suspense: boolean;
    destination: string | null;
}>({
    page: false,
    suspense: false,
    destination: null,
});

export { loadingState };
